import React from 'react'
import RoutesLayout from './LayoutRoute/RoutesLayout'

function App() {
  return (
    <div><RoutesLayout/></div>
  )
}

export default App